export default "__VITE_ASSET__d947b06c__"